import React, { useRef, useState } from "react";
import { styled } from "../../../../stitches.config";

import WithLazyLoad from "../../../HOCs/WithLazyLoad";
import AnimateHeightWrapper, { AnimateWrapperButton } from "../../Parts/Brid/common/components/AnimateHeightWrapper";

import useMediaQuery from "../../../../helpers/useMediaQuery";
import shareIcon from "../../../../redesign/assets/icons/socialbutton-share.svg"


const InfogramPost = (props) => {

    const isDesktop = useMediaQuery('bp3');
    const [visibility, setVisibility] = useState(false)

    const ref = (node) => {
        if (node !== null) {

            let interlvalId = setInterval(() => {
                let height = node.getBoundingClientRect().height
                console.log(height)
                if (height != undefined && height > 0) {
                    if (height > 450) {
                        setVisibility(true);
                    }

                    clearInterval(interlvalId);
                }
            }, 1000);
        }
    };


    return (
        <WithLazyLoad options={{
            height: 480,
            once: true,
            offset: 600
        }}>
            <AnimateHeightWrapper type={AnimateWrapperButton.ShowMore} height={450} visibility={visibility}>
                <CenteredEmbed ref={ref} >
                    <iframe
                        title="embed"
                        src={props.url}
                        frameBorder="0"
                        width={isDesktop ? "700" : "320"}
                        height={isDesktop ? "800" : "400"}
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    />
                </CenteredEmbed>
            </AnimateHeightWrapper>

        </WithLazyLoad>
    );
}

export default InfogramPost;


const CenteredEmbed = styled("div", {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "325px",
    position: "relative",
    "&::before": {
        minHeight: "100px",
        height: "100%",
        content: "",
        backgroundSize: "80px",
        opacity: 0.4,
        top: "0",
        left: "0",
        right: "0",
        position: "absolute",
        zIndex: 0
    },
    iframe: {
        position: "relative"
    }
});